import store from '@/store';
import ClientService from '@/features/Client/services/client.service';
import Vue from 'vue';

export const CLIENT = {
  namespaced: true,
  state: {
    selectedClient: null,
    clients: [],
    clientsCounts: [],
    clientsCountsLoading: false,
    loading: false,
  },
  getters: {
    GET_SELECTED_CLIENT(state) {
      return state.selectedClient;
    },
    GET_CLIENTS_COUNTS(state) {
      return state.clientsCounts;
    },
    GET_CLIENTS_COUNTS_LOADING(state) {
      return state.clientsCountsLoading;
    },
    GET_CLIENTS(state) {
      return state.clients;
    },
    GET_LOADING(state) {
      return state.loading;
    }
  },
  mutations: {
    SET_SELECTED_CLIENT(state, val) {
      state.selectedClient = val;
    },
    SET_CLIENTS_COUNTS(state, val) {
      state.clientsCounts = val;
    },
    SET_CLIENTS_COUNTS_LOADING(state, val) {
      state.clientsCountsLoading = val;
    },
    SET_CLIENTS(state, val) {
      state.clients = val;
    },
    SET_LOADING(state, val) {
      state.loading = val;
    }
  },
  actions: {
    async GET_CLIENTS_COUNTS({ commit }, providedCompanyId) {
      commit("SET_CLIENTS_COUNTS_LOADING", true);

      // Use provided companyId or fallback to current company
      let companyId = providedCompanyId || store.getters["ACCOUNT/GET_COMPANY"]?.id;

      ClientService.getCounts({}, companyId).then(({ data }) => {
        commit("SET_CLIENTS_COUNTS", data);
      }).catch(() => {
        Vue.prototype.$dialog.notify.error("Failed to fetch clients counts");
      }).finally(() => {
        commit("SET_CLIENTS_COUNTS_LOADING", false);
      });
    },
    async GET_CLIENTS({ commit }, providedCompanyId) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true);
        let companyId = providedCompanyId || store.getters["ACCOUNT/GET_COMPANY"]?.id;

        ClientService.get({}, companyId).then(({ data }) => {
          commit('SET_CLIENTS_COUNTS', data.total);
          commit('SET_CLIENTS', data.items);
          resolve(data.items);
        }).catch(() => {
          Vue.prototype.$dialog.notify.error('Failed to fetch clients');
          reject();
        }).finally(() => {
          commit('SET_LOADING', false);
        });
      });
    },
    async ADD_CLIENT({ state }, payload) {
      return new Promise((resolve, reject) => {
        const { data, companyId } = typeof payload === 'object' && payload.data ? payload : { data: payload, companyId: null };
        const effectiveCompanyId = companyId || store.getters["ACCOUNT/GET_COMPANY"]?.id;
        
        ClientService.add(data, effectiveCompanyId).then(({ data }) => {
          Vue.prototype.$dialog.notify.success('Client added successfully');
          state.clients.push(data);
          resolve(data);
        }).catch(() => {
          Vue.prototype.$dialog.notify.error('Failed to add client');
          reject();
        });
      });
    },
    async UPDATE_CLIENT({ state }, payload) {
      return new Promise((resolve, reject) => {
        const { data, companyId } = typeof payload === 'object' && payload.data ? payload : { data: payload, companyId: null };
        const effectiveCompanyId = companyId || store.getters["ACCOUNT/GET_COMPANY"]?.id;
        
        ClientService.update(data, effectiveCompanyId).then(({ data: updatedClient }) => {
          Vue.prototype.$dialog.notify.success('Client updated successfully');
          const index = state.clients.findIndex(client => client.id === updatedClient.id);
          if (index !== -1) {
            Vue.set(state.clients, index, updatedClient);
          }
          resolve(updatedClient);
        }).catch(() => {
          Vue.prototype.$dialog.notify.error('Failed to update client');
          reject();
        });
      });
    },
    async DELETE_CLIENT({ state }, payload) {
      return new Promise((resolve, reject) => {
        const { id, companyId } = typeof payload === 'object' && payload.id ? payload : { id: payload, companyId: null };
        const effectiveCompanyId = companyId || store.getters["ACCOUNT/GET_COMPANY"]?.id;
        
        ClientService.delete(id, effectiveCompanyId).then(() => {
          Vue.prototype.$dialog.notify.success('Client deleted successfully');
          state.clients = state.clients.filter(client => client.id !== id);
          resolve();
        }).catch(() => {
          Vue.prototype.$dialog.notify.error('Failed to delete client');
          reject();
        });
      });
    }
  },
} 